export const SET_STOCK = 'SET_STOCK'
export const RESET_STOCK = 'RESET_STOCK'

export const setStock = stock => ({
  type: SET_STOCK,
  stock
})

export const resetStock = () => ({
  type: RESET_STOCK
})
